(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".announcement-vertical-slider");
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll(".announcement-slide"));
  if (slides.length <= 1) return;

  const slideHeight = slides[0].offsetHeight;

  // Duplicate first slide for seamless loop
  const firstClone = slides[0].cloneNode(true);
  slider.appendChild(firstClone);

  let currentIndex = 0;

  function showNextSlide() {
    currentIndex++;
    slider.style.transition = "transform 0.5s ease-in-out";
    slider.style.transform = `translateY(-${currentIndex * slideHeight}px)`;

    if (currentIndex >= slides.length) {
      setTimeout(() => {
        slider.style.transition = "none";
        slider.style.transform = "translateY(0)";
        currentIndex = 0;
        void slider.offsetWidth; // force reflow for smooth restart
        slider.style.transition = "transform 0.5s ease-in-out";
      }, 500);
    }
  }

  slider.style.transform = "translateY(0)";
  setInterval(showNextSlide, 5000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
